import React from 'react'
import {HandsOnTable,DateField, TextBox, DropDown, Label, TextArea, Tab, TabPage, Button, Grid, GridBody, GridHeader, LovComboBox, AddRowButton, DualStateSelector, ControlCenter, NewButton, SaveButton, RefreshButton, DeleteButton, PopulateButton, CheckBox, PopUpPage, IntegerField, NumberField, AdvanceSearch, AdvanceSearchGrid, AdvanceSearchButton } from '../../../BASE/Components'

export function generateTransactionSummaryDisplay(componentList, control) {

    return (
        <>
        <ControlCenter item={componentList["CONTROL_CENTER"]} >
            <div className="loading" id="spinner" style={{ display: "none",position:"relative",zIndex:"99999" }}>Loading&#8230;</div>

            <div className="page-header-wrp">
                <div className="title-breadcrumb-wrp">
                    <h1 className="">{componentList["CONTROL_CENTER"].label.schema.value}</h1>
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <ControlCenter item={componentList["CONTROL_CENTER"]} >

                            <PopulateButton className="btn common-btn common-btn-erp btn-sm mr-2" item={componentList["buttonPopulate"]}><i className="fas fa-database fa-lg"></i></PopulateButton>

                        </ControlCenter>
                    </div>
                </div>
                
            </div>

            <div className="container-fluid custom-container-padding">
                <div className="form-wrp background-white" style={{position:"relative",zIndex:"9999"}}>
                    <div className="row" style={{position:"relative",zIndex:"9999"}}>
                        <div className="col-12">
                            <div className="form-row">
                                
                                <div className="form-group col-md-3" style={{position:"relative",zIndex:"9999"}}>
                                    <Label item={componentList["inputFromDate"].label} />
                                    <DateField item={componentList["inputFromDate"]} dateFormat="yyyy-MM-dd" />
                                </div>
                                {/* <div className='col-md-2 form-group'>   </div> */}
                                <div className="form-group col-md-3" style={{position:"relative",zIndex:"9999"}}>
                                    <Label item={componentList["inputToDate"].label} />
                                    <DateField item={componentList["inputToDate"]} dateFormat="yyyy-MM-dd" />
                                </div>

                                

                            </div>
                        </div>
                    </div>
                </div>

                
              
            </div>

            <div className="container-fluid custom-container-padding">
                <div className="form-wrp background-white pb-1 pt-2">
                    <div className="row no-gutters">

                        {/* CASH section */}
                        <div className="col-12 px-1 mb-1">
                            <div style={{ fontSize: '10px', fontWeight: 700, color: '#5a5a5a', textTransform: 'uppercase', letterSpacing: '0.6px', borderBottom: '1px solid #e0e0e0', paddingBottom: '2px', marginBottom: '4px' }}>
                                <i className="fas fa-money-bill-wave mr-1"></i>Cash
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#e8f5e9', borderLeft: '3px solid #43a047', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#2e7d32', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>CR</div>
                                <div style={{ fontSize: '14px', color: '#1b5e20', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].cashCr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#ffebee', borderLeft: '3px solid #e53935', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#c62828', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>DR</div>
                                <div style={{ fontSize: '14px', color: '#b71c1c', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].cashDr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12 px-1 mb-1">
                            <div style={{
                                borderRadius: '6px',
                                background: componentList["summaryData"].cashNet >= 0 ? '#e8f5e9' : '#ffebee',
                                borderLeft: `3px solid ${componentList["summaryData"].cashNet >= 0 ? '#43a047' : '#e53935'}`,
                                padding: '6px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                            }}>
                                <div>
                                    <div style={{ fontSize: '10px', color: componentList["summaryData"].cashNet >= 0 ? '#2e7d32' : '#c62828', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Net</div>
                                    <div style={{ fontSize: '14px', color: componentList["summaryData"].cashNet >= 0 ? '#1b5e20' : '#b71c1c', fontWeight: 700, marginTop: '2px' }}>
                                        {componentList["summaryData"].cashNet.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </div>
                                </div>
                                <i className={`fas fa-${componentList["summaryData"].cashNet >= 0 ? 'arrow-up' : 'arrow-down'}`}
                                    style={{ color: componentList["summaryData"].cashNet >= 0 ? '#43a047' : '#e53935', fontSize: '16px' }}></i>
                            </div>
                        </div>

                        {/* BANK section */}
                        <div className="col-12 px-1 mb-1 mt-1">
                            <div style={{ fontSize: '10px', fontWeight: 700, color: '#5a5a5a', textTransform: 'uppercase', letterSpacing: '0.6px', borderBottom: '1px solid #e0e0e0', paddingBottom: '2px', marginBottom: '4px' }}>
                                <i className="fas fa-university mr-1"></i>Bank
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#e3f2fd', borderLeft: '3px solid #1e88e5', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#1565c0', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>CR</div>
                                <div style={{ fontSize: '14px', color: '#0d47a1', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].bankCr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#fff3e0', borderLeft: '3px solid #fb8c00', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#e65100', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>DR</div>
                                <div style={{ fontSize: '14px', color: '#bf360c', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].bankDr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12 px-1 mb-1">
                            <div style={{
                                borderRadius: '6px',
                                background: componentList["summaryData"].bankNet >= 0 ? '#e3f2fd' : '#fff3e0',
                                borderLeft: `3px solid ${componentList["summaryData"].bankNet >= 0 ? '#1e88e5' : '#fb8c00'}`,
                                padding: '6px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                            }}>
                                <div>
                                    <div style={{ fontSize: '10px', color: componentList["summaryData"].bankNet >= 0 ? '#1565c0' : '#e65100', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Net</div>
                                    <div style={{ fontSize: '14px', color: componentList["summaryData"].bankNet >= 0 ? '#0d47a1' : '#bf360c', fontWeight: 700, marginTop: '2px' }}>
                                        {componentList["summaryData"].bankNet.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </div>
                                </div>
                                <i className={`fas fa-${componentList["summaryData"].bankNet >= 0 ? 'arrow-up' : 'arrow-down'}`}
                                    style={{ color: componentList["summaryData"].bankNet >= 0 ? '#1e88e5' : '#fb8c00', fontSize: '16px' }}></i>
                            </div>
                        </div>

                        {/* Overall Net Balance */}
                        <div className="col-12 px-1 mt-1 mb-1">
                            <div style={{
                                borderRadius: '6px',
                                background: componentList["summaryData"].netBalance >= 0 ? '#e8f5e9' : '#ffebee',
                                borderLeft: `3px solid ${componentList["summaryData"].netBalance >= 0 ? '#43a047' : '#e53935'}`,
                                padding: '6px 10px',
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                            }}>
                                <div style={{ fontSize: '10px', color: componentList["summaryData"].netBalance >= 0 ? '#2e7d32' : '#c62828', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    <i className="fas fa-balance-scale mr-1"></i>Overall Net Balance (CR - DR)
                                </div>
                                <div style={{ fontSize: '14px', color: componentList["summaryData"].netBalance >= 0 ? '#1b5e20' : '#b71c1c', fontWeight: 700 }}>
                                    {componentList["summaryData"].netBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    <i className={`fas fa-${componentList["summaryData"].netBalance >= 0 ? 'arrow-up' : 'arrow-down'} ml-2`}
                                        style={{ fontSize: '11px' }}></i>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid custom-container-padding">
                <div className="form-wrp background-white">
                    <div className="scroll-thin txn-summary-grid">
                        <HandsOnTable item={componentList["gridTransactionSummary"]}  />
                    </div>
                </div>
            </div>
            </ControlCenter>
        </>
    )
}
